import drycleanOne from '../assets/webp/drycleanOne.webp';
import drycleanTwo from '../assets/webp/drycleanTwo.webp';
import tailoringOne from '../assets/webp/tailoringOne.webp';
import tailoringTwo from '../assets/webp/tailoringTwo.webp';
import washfoldOne from '../assets/webp/washfoldOne.webp';
import washfoldTwo from '../assets/webp/washfoldTwo.webp';
import { MdOutlineCalendarToday, MdOutlinePriceCheck } from "react-icons/md";
import { PiTShirtBold } from "react-icons/pi";
import { MdOutlineBubbleChart } from "react-icons/md";
import { FiThumbsUp, FiCheckSquare, FiBell } from "react-icons/fi";
import { HiOutlineReceiptPercent } from "react-icons/hi2";
import { TbBulb } from "react-icons/tb";
import { FaTruckFast } from "react-icons/fa6";
import { IoStorefrontOutline } from 'react-icons/io5';
import { RiUserCommunityLine } from 'react-icons/ri';

export const washFold = {
  title: "Wash & Fold",
  description: "Convenient wash and fold laundry service with pickup and delivery for your everyday clothing needs.",
  images: [
    { src: washfoldOne, alt: "Folding Laundry" },
    { src: washfoldTwo, alt: "Folded Towels" }
  ]
};

export const dryClean = {
  title: "Dry Clean",
  description: "A convenient way to care for garments that need a more refined finish.",
  images: [
    { src: drycleanOne, alt: "Washing Machin" },
    { src: drycleanTwo, alt: "Machin" }
  ]
};

export const tailoring = {
  title: "Tailoring",
  description: "Professional tailoring and clothing alteration service with easy pickup and delivery.",
  images: [
    { src: tailoringOne, alt: "Machin" },
    { src: tailoringTwo, alt: "Thread" }
  ]
};

export const featureListData = [
  {
    icon: MdOutlineCalendarToday,
    title: "Request a pickup",
    description: "Choose a pickup time that works for your routine. A Tydii driver collects your laundry from your doorstep and connects your order with a trusted local laundry partner for professional wash and fold service."
  },
  {
    icon: MdOutlineBubbleChart,
    title: "Washed carefully, folded neatly",
    description: "Your clothes are handled by experienced local laundry professionals with attention to sorting, washing, drying, and folding. From everyday garments to household essentials, each order is processed with care and consistency."
  },
  {
    icon: PiTShirtBold,
    title: "Fresh laundry delivered back",
    description: "Your laundry is returned clean, folded, and ready to use. Many wash and fold orders are completed within 24–48 hours, giving you a simple laundry pickup and delivery experience that saves time every week."
  }
];


export const DryCleanListData = [
  {
    icon: MdOutlineCalendarToday,
    title: "Book a pickup",
    description: "CChoose a pickup time that works for you. A Tydii driver will collect your dry-cleaning items from your home or office, making the process simple and hassle-free."
  },
  {
    icon: MdOutlineBubbleChart,
    title: "Handled by trusted local specialists",
    description: "Your garments are cared for by experienced local dry-cleaning partners available through the Tydii platform. Each provider offers professional garment care, helping ensure your items receive the attention they need."
  },
  {
    icon: PiTShirtBold,
    title: "Delivered fresh, finished, and ready to wear",
    description: "Delivery timelines may vary by provider, but many orders are completed within 24–48 hours. Your garments are returned clean, pressed, and ready to wear, so your routine stays uninterrupted."
  }
];

export const TailoringListData = [
  {
    icon: MdOutlineCalendarToday,
    title: "Schedule a pickup",
    description: "Choose a pickup time that works for you. A Tydii driver collects your garments from your home or office, making clothing alterations and tailoring services simple and convenient."
  },
  {
    icon: MdOutlineBubbleChart,
    title: "Tailored by trusted local experts",
    description: "Your garments are handled by experienced local tailors available through the Tydii platform. From hemming and tapering to minor repairs and fit adjustments, each order is managed with care, precision, and clear service options."
  },
  {
    icon: PiTShirtBold,
    title: "Delivered fitted and ready to wear",
    description: "Most tailoring and alteration orders are completed within 2–5 days, depending on the garment and request. Your items are returned repaired, adjusted, and ready to wear without the need for an extra trip to the shop."
  }
];


export const whyChooseUs = [
  {
    icon: RiUserCommunityLine,
    title: "Support Local Businesses",
    quote:"Every order strengthens your community.",
    desc:
      "When you book through Tydii, you support independent neighborhood shops, helping them grow without costly marketing or delivery overhead.",
  },
  {
    icon: IoStorefrontOutline,
    title: "Choose Your Favorite Store",
    quote:"You’re in control.",
    desc:
      "Tydii is a marketplace, so you decide exactly which local laundromat, dry cleaner, or tailor handles your order, based on pricing, turnaround times, and reviews. You can book with your favorite store, or find your new favorite one.",
  },
  {
    icon: FiThumbsUp,
    title: "Peace of Mind Guarantee",
    quote:"We stand behind every order.",
    desc:
      "Tydii protects your items with up to $100 declared value coverage, giving you confidence in the services you choose. If your items cost more, you can also let us know for more protection.",
  },
  {
    icon: FiCheckSquare,
    title: "Convenience, On Your Terms",
    quote:"Pickup and delivery whenever it fits your schedule. ",
    desc:
      "Turnaround times vary by provider, and many offer 24–48 hour service, with some offering same-day care.",
  },
  {
    icon: MdOutlinePriceCheck,
    title: "Transparent Pricing",
    quote:"See pricing upfront from each provider before you book. ",
    desc:
      "If there’s a difference in weight or item count, your provider may adjust the total — and you’ll always be notified before the work begins",
  },
  {
    icon: FiBell,
    title: "Instant Order Update",
    quote:"Real-time updates on your order status.",
    desc:
      "Get regular updates on your order to help you track progress and plan accordingly.",
  },
];


export const faqs = [
  {
    q: "What is Tydii and how does it work?",
    a: "Tydii is a simple way to get your laundry, dry cleaning, and tailoring done without leaving your home. We connect you to trusted local laundromats, dry cleaners, and tailors in your neighborhood. Just schedule a pickup, and we’ll deliver your items back clean, pressed, or perfectly hemmed, right to your door.",
  },
  {
    q: "Where does Tydii offer laundry and dry cleaning delivery?",
    a: "We currently serve Cambridge, MA; Somerville, MA; Revere, MA; and select areas of Boston. 📍 Not in your area yet? Join our waitlist to be the first to know when we launch near you.",
  },
  {
    q: "How much does Tydii cost?",
    a: "Tydii offers transparent pricing; you pay the local laundromat, dry cleaner, or tailor directly through our platform. Prices vary by provider and service, but you'll always see the total before you confirm your order. Wash & Fold: From $1.70/lb. Dry Cleaning: Per item (e.g., shirts, suits, dresses). Tailoring & Alterations: Based on request.",
  },
  {
    q: "Who provides the laundry, dry cleaning, and tailoring services?",
    a: "We partner with trusted, local laundromats, dry cleaners, and tailors—the same small businesses you’ve relied on for years, now available with modern convenience. We vet each provider to ensure high-quality service, reliability, and care.",
  },
  {
    q: "What laundry or dry cleaning preferences can I choose?",
    a: "Preferences vary by provider, but you can often request: hypoallergenic or fragrance-free detergent, hang drying or delicate wash, stain treatment, press-only or dry clean only, and tailoring notes (e.g., hem, taper, adjustments). We’ll always match you with a provider that can meet your needs.",
  },
  {
    q: "How does payment work?",
    a: "All payments are made securely online through Tydii. You’ll pay the listed service prices from your matched laundromat, dry cleaner, or tailor; no hidden fees or in-person payments required.",
  },
  {
    q: "How fast is the turnaround time?",
    a: "Turnaround time depends on your selected service provider and type of service. Most wash & fold orders are returned in 24–48 hours, while dry cleaning and tailoring may take longer depending on the items.",
  },
  {
    q: "Can I track my laundry order?",
    a: "Yes! You'll get real-time updates via text or app notifications when your clothes are picked up, cleaned, and on the way back to you.",
  },
  {
    q: "Is there a minimum order amount?",
    a: "Minimums are set by each laundromat, dry cleaner, or tailor, and you’ll see those clearly before confirming your order.",
  },
  {
    q: "What happens if something goes wrong with my order?",
    a: "We’ve got your back. If there’s an issue with your service or delivery, our support team is here to help. Just reach out through the app or email us at help@tydii.io and we’ll work to make it right.",
  },
  {
    q: "Do I need to sort my laundry before pickup?",
    a: "Nope. Just separate your items by type (e.g., wash & fold vs. dry cleaning), and your local provider will take it from there. For now it's good to print out your name and order number. Make sure your bag is easily identified by our driver and the shops.",
  },
  {
    q: "Can I request tailoring or alterations through Tydii?",
    a: "Yes! Select tailoring during your order and include details on what you’d like done; whether it’s hemming pants, altering a dress, or fixing buttons. We’ll match you with a local tailor who can handle it.",
  },
  {
    q: "Why use Tydii instead of going to a laundromat or dry cleaner myself?",
    a: "Because your time matters. Tydii brings professional laundry, dry cleaning, and tailoring from trusted local providers to your doorstep. No waiting, no traffic, no stress. Just clean clothes, more free time, and support for small businesses in your community.",
  },
];

export const faqsForCustomers = [
  {
    q: "What is Tydii and how does it work?",
    a: "Tydii helps you book laundry, dry cleaning, and tailoring pickup and delivery from trusted local businesses. You place an order online, choose your service preferences, and your items are picked up, processed by a trusted local partner, and returned to your doorstep.",
  },
  {
    q: "What services can I book on Tydii?",
    a: "You can book wash and fold, dry cleaning, ironing or press-only requests, and selected tailoring or alteration services. Service availability may vary by location and by the partner business matched to your order.",
  },
  {
    q: "Where is Tydii available?",
    a: "Tydii serves selected neighborhoods based on operating coverage and partner availability. Enter your address or ZIP code on the platform to see whether pickup and delivery is currently available in your area.",
  },
  {
    q: "How do I place my first order?",
    a: "Create an account, enter your address, choose the service you need, select your pickup and delivery slots, add any preferences, and confirm payment. You will receive order updates once the booking is accepted.",
  },
  {
    q: "How much does Tydii cost?",
    a: "Pricing depends on the service type, the local laundry or dry-cleaning partner, and your order details. Tydii shows your price clearly before confirmation so you know the expected total before placing the order. If your order’s weight or item count differs from what you entered, your partner may adjust the price, and you’ll be notified before they begin cleaning.",
  },
  {
    q: "Is there a minimum order amount?",
    a: "Some partner laundries or dry cleaners may require a minimum order value for pickup and delivery. If a minimum applies, it will be shown before you complete the checkout.",
  },
  {
    q: "How do payments work?",
    a: "Payments are completed securely through the Tydii platform. You can review your charges before confirming the order, and any final adjustments for extra services should be communicated clearly through the app or support workflow.",
  },
  {
    q: "How fast is turnaround time?",
    a: "Most standard laundry orders are returned within one to two days, while dry cleaning or tailoring may take longer depending on item type and workload. While your date preference is our priority, please expect that the return date depends entirely on the partners’ turnaround time.",
  },
  {
    q: "Can I track my order status?",
    a: "Yes. Tydii provides live updates so you can see when your order is booked, picked up, in processing, out for delivery, and completed.",
  },
  {
    q: "Do I need to sort my clothes before pickup?",
    a: "It is best to separate laundry, dry-cleaning items, and tailoring requests before pickup. Clear separation helps avoid confusion and ensures the right partner handles each item correctly.",
  },
  {
    q: "Can I add special instructions or laundry preferences?",
    a: "Yes. You can usually add notes such as fragrance-free detergent, hang dry, stain treatment, delicate handling, press-only, or tailoring instructions. Tydii will route your order only to a partner that can support those needs when possible.",
  },
  {
    q: "Do I need to be home for pickup or delivery?",
    a: "Not always. If contactless pickup or drop-off is available in your area, you can leave instructions for a safe and accessible handoff location. For higher-value or sensitive orders, an attended handoff may still be recommended.",
  },
  {
    q: "What happens if I miss my pickup or delivery window?",
    a: "If a pickup or delivery attempt is missed, you may need to reschedule through the app or with support. Depending on timing and local policy, a missed-attempt or re-delivery fee may apply.",
  },
  {
    q: "Can I reschedule my order?",
    a: "Yes. You can request a schedule change before the assigned window begins. Rescheduling is easier when requested early, because late changes may affect routing and availability.",
  },
  {
    q: "Who cleans my clothes?",
    a: "Your order is handled by a trusted local laundromat, dry cleaner, or tailor partnered with Tydii. Our platform is designed to support neighborhood businesses while giving customers a more convenient pickup-and-delivery experience.",
  },
  {
    q: "What if an item is delayed, missing, or damaged?",
    a: "If something goes wrong, contact Tydii support as soon as possible through the platform or support email. Share order details and, when relevant, photos or a description of the issue so the team can investigate with the service partner quickly.",
  },
  {
    q: "Can I request tailoring or alterations through Tydii?",
    a: "Yes. If tailoring is available in your area, you can include your alteration request during booking and add notes about the changes needed. Complex fitting adjustments may require additional review or confirmation.",
  },
  {
    q: "Why should I use Tydii instead of going directly to a laundromat?",
    a: "Tydii saves time by bringing pickup and delivery to your door while still supporting trusted local laundry businesses. It combines convenience, transparent ordering, and service updates in one place.",
  },
];


export const faqsForLaundryOwners = [
  {
    q: "What is Tydii for laundry business owners?",
    a: "Tydii helps laundromats, dry cleaners, and tailoring shops receive more orders through a managed digital platform. It can handle customer acquisition, order flow, pickup and delivery coordination, and communication updates.",
  },
  {
    q: "Who can partner with Tydii?",
    a: "Independent laundromats, dry cleaners, and tailoring businesses with reliable service quality, consistent turnaround, and the ability to handle pickup-and-delivery orders may be eligible to join the platform.",
  },
  {
    q: "How does Tydii send orders to my business?",
    a: "Orders are routed through the Tydii platform based on service type, area coverage, availability, and operational fit. You receive order details, customer preferences, and pickup or delivery status through the partner workflow.",
  },
  {
    q: "Do I control my pricing?",
    a: "Pricing structure depends on the Tydii partnership model. In many cases, your service pricing, minimums, and category rates are defined during onboarding and then displayed to customers in a standardized format.",
  },
  {
    q: "Are there onboarding or partner fees?",
    a: "Commercial terms, fees, or commissions are typically shared during onboarding. These may vary based on market, delivery support, service categories, and the tools included in your partnership arrangement.",
  },
  {
    q: "How do payouts work?",
    a: "Payout timing and settlement structure are defined in your partner agreement. You should receive a clear breakdown showing completed orders, deductions if any, and the amount payable for the payout cycle.",
  },
  {
    q: "Can I set order minimums?",
    a: "Yes, minimums can usually be configured by service type or by order value, depending on the operating model used in your market. These minimums help maintain profitability on pickup-and-delivery orders.",
  },
  {
    q: "Can I pause new orders when I am at capacity?",
    a: "Tydii should support operational controls for availability, order throttling, or temporary pause requests. This helps you manage quality during peak periods instead of accepting more work than you can fulfill well.",
  },
  {
    q: "What service standards are expected from partner businesses?",
    a: "Partners are expected to follow quality, turnaround, packaging, tagging, and communication standards. These standards help reduce errors, improve customer trust, and keep service levels consistent across the platform.",
  },
  {
    q: "How should I prepare items when an order arrives?",
    a: "At intake, confirm item count, service type, special instructions, and garment condition. Proper tagging and exception logging at the start of the job are essential to prevent mix-ups and claims later.",
  },
  {
    q: "What happens if a customer adds special preferences?",
    a: "Special instructions such as fragrance-free detergent, stain treatment, delicate handling, or tailoring notes should be reviewed before processing. If a request cannot be fulfilled, it should be flagged early through the partner support workflow.",
  },
  {
    q: "Who handles pickup and delivery logistics?",
    a: "Depending on the local operating model, logistics may be handled by Tydii-managed delivery partners, by the store, or through a hybrid process. The responsibility model should be clearly defined during partner setup.",
  },
  {
    q: "How are missing or damaged item claims handled?",
    a: "Claims are usually investigated using intake records, order tags, timestamps, notes, and any available photos. Fast and accurate recordkeeping greatly improves resolution speed and reduces avoidable disputes.",
  },
  {
    q: "What if I cannot complete an order on time?",
    a: "If you expect a delay, notify Tydii as early as possible so the customer can be informed and the delivery plan can be updated. Early escalation is better than missing the promised turnaround without notice.",
  },
  {
    q: "Can I offer tailoring or premium services through Tydii?",
    a: "Yes, if your shop is equipped for those services and approved for them during onboarding. Expanding into higher-value categories can improve order value when service quality is consistent.",
  },
  {
    q: "How does Tydii help me grow my business?",
    a: "Tydii can help you reach new customers, increase repeat business, improve digital convenience, and participate in a pickup-and-delivery model without building the full customer-facing platform yourself.",
  },
];

export const faqsForDeliveryPartners = [
  {
    q: "What is a Tydii delivery partner?",
    a: "A Tydii delivery partner is responsible for picking up laundry orders from customers, transporting them safely to the assigned business, and returning completed orders on time with proper proof of handoff.",
  },
  {
    q: "Who can become a delivery partner?",
    a: "Eligibility depends on the market and may include identity verification, vehicle or transport suitability, smartphone access, and the ability to follow service, safety, and communication requirements consistently.",
  },
  {
    q: "How do I receive delivery assignments?",
    a: "Assignments are shared through the delivery workflow or app based on your area, availability, and active routes. You should review pickup notes, item count instructions, and time windows before starting the trip.",
  },
  {
    q: "What should I do at pickup?",
    a: "At pickup, confirm the correct customer, number of bags or items, visible condition issues if any, and any special notes. A careful handoff at pickup helps avoid later disputes about missing, mixed, or damaged orders.",
  },
  {
    q: "What should I do at the drop-off?",
    a: "At drop-off, verify the order details, follow delivery instructions, and record proof of completion when required. This may include a timestamp, photo confirmation, or direct handoff acknowledgment.",
  },
  {
    q: "Do I need to open or inspect customer bags?",
    a: "No. Delivery partners should not open customer bags unless platform policy explicitly requires a visible count confirmation procedure. Respecting privacy and maintaining chain-of-custody is important.",
  },
  {
    q: "What if I cannot reach the customer?",
    a: "Follow the in-app contact steps, review delivery notes, and wait only for the allowed time under policy. If the customer is unreachable, log the failed attempt and escalate through support before leaving the location.",
  },
  {
    q: "What if building access is blocked?",
    a: "Use the contact details or call instructions provided in the order notes. Never force entry, tailgate into restricted areas, or leave items in an unsafe place without approved contactless-delivery permission.",
  },
  {
    q: "What if a bag is leaking, torn, or unsafe to transport?",
    a: "Photograph the issue if policy allows, notify support immediately, and follow safety procedures. If the order presents a contamination or hazard risk, do not transport it until guidance is received.",
  },
  {
    q: "How are earnings calculated?",
    a: "Earnings depend on the local partner model and may reflect completed pickups, completed deliveries, active route payouts, or other agreed compensation terms. Your payment structure should be explained clearly during onboarding.",
  },
  {
    q: "When do I get paid?",
    a: "Payout timing depends on the delivery partner settlement cycle in your market. The platform should provide visibility into completed jobs, payable amount, and payout timing.",
  },
  {
    q: "What happens if I am late to a stop?",
    a: "If you are running late, update the platform or support team as early as possible so customers and partner businesses can be informed. Repeated delays may affect performance standing.",
  },
  {
    q: "Can I reject an assignment?",
    a: "Assignment flexibility depends on the operating model. If reassignment is allowed, respond promptly so the order can be routed to another available partner without affecting customer service.",
  },
  {
    q: "What documents or proof do I need for completed deliveries?",
    a: "Use the required proof format for your market, such as photo confirmation, marked completion in the app, or direct handoff acknowledgment. Accurate proof protects both you and the platform in case of disputes.",
  },
  {
    q: "Who do I contact if there is a problem during a route?",
    a: "Use the designated Tydii support channel for urgent operational issues, customer no-shows, item concerns, safety problems, or technical issues with the delivery workflow. Report problems immediately rather than resolving risky situations alone.",
  },
  {
    q: "What makes a strong delivery partner on Tydii?",
    a: "Reliability, careful handling, punctuality, good communication, and accurate proof of handoff are the most important qualities. A strong delivery partner helps build trust for both customers and local laundry businesses.",
  },
];

export const customerTestimonials = [
  {
    id: "c1",
    quote:
      "I'm not even gonna lie, I used to just let laundry pile up. Now I just open the app and it's gone. I don't really think about it anymore.",
  },
  {
    id: "c2",
    quote:
      "The biggest thing for me is I can actually pick the shop. I know who's cleaning my clothes and that matters.",
  },
  {
    id: "c3",
    quote:
      "It's not like those big services where everything feels the same. These are actual local spots. Tydii just picks it up and the store does everything.",
  },
  {
    id: "c4",
    quote:
      "I didn't realize how annoying laundry was until I stopped doing it myself.",
  },
  {
    id: "c5",
    quote:
      "Yeah… I'm not carrying laundry bags around anymore. That alone is enough for me.",
  },
];

export const businessOwnerTestimonials = [
  {
    id: "b1",
    quote:
      "We've been here a long time, but it was mostly regulars and walk-ins. Tydii started bringing in new people we've never seen before.",
  },
  {
    id: "b2",
    quote:
      "We always wanted to do delivery, but it just wasn't realistic for us. Tydii made it easy without us changing how we work.",
  },
  {
    id: "b3",
    quote:
      "The good part is nothing really changed on our end. We still set our prices, we still run our shop. There's just more orders now.",
  },
  {
    id: "b4",
    quote:
      "Before this, if you weren't nearby, you probably weren't coming to us. Now distance doesn't really matter.",
  },
  {
    id: "b5",
    quote:
      "It's not just extra business, it's steady. That's the difference.",
  },
];